module.exports = __webpack_public_path__ + "static/img/y11.9c732c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y11.jpg
// module id = HWmi
// module chunks = 1